export enum ScanStatus {
  scan = 'scan',
  ok = 'ok',
  error = 'error',
}